import { render, staticRenderFns } from "./knowledge-base.vue?vue&type=template&id=597ed380&scoped=true&"
import script from "./knowledge-base.vue?vue&type=script&lang=js&"
export * from "./knowledge-base.vue?vue&type=script&lang=js&"
import style0 from "./knowledge-base.vue?vue&type=style&index=0&id=597ed380&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597ed380",
  null
  
)

export default component.exports